import { render, staticRenderFns } from "./NotAllowed.vue?vue&type=template&id=570b46f0&"
import script from "./NotAllowed.vue?vue&type=script&lang=ts&"
export * from "./NotAllowed.vue?vue&type=script&lang=ts&"
import style0 from "./NotAllowed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports